module.exports = __webpack_public_path__ + "static/media/Call_Phone_Mobile.34cb8acc.svg";